import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Grid,
} from "@mui/material";

const Choice = ({ question, onChange }) => {
  // Initialize the value with the existing answer
  let initialValue = "";
  try {
    if (
      question.questionType === "multipleChoice" ||
      (question.questionType === "related" &&
        question.matchingCriteria === "multiple")
    ) {
      initialValue =
        typeof question.answer === "string" ? question.answer.split(",") : [];
    } else {
      initialValue = question.answer || "";
    }
  } catch (e) {
    console.error("Error parsing initialValue in Choice:", e);
    initialValue = "";
  }

  const [value, setValue] = useState(initialValue);

  const handleChange = (event) => {
    const newValue = event.target.value; // Simplified since both cases assign event.target.value

    setValue(newValue); // Update local state

    // Join the array for multipleChoice before passing it up
    const formattedValue =
      question.questionType === "multipleChoice" ||
      (question.questionType === "related" &&
        question.matchingCriteria === "multiple")
        ? Array.isArray(newValue)
          ? newValue.join(",")
          : newValue
        : newValue;

    onChange(question._id, formattedValue); // Notify parent
  };

  // Refactored isMultiple as a variable for clarity
  const isMultiple =
    question.questionType === "multipleChoice" ||
    (question.questionType === "related" &&
      question.matchingCriteria === "multiple");

  return (
    <Grid item xs={12}>
      <FormControl fullWidth>
        <InputLabel>
          {question.question}
          {question.required ? " *" : ""}
        </InputLabel>
        <Select
          multiple={isMultiple} // Correctly passing a boolean
          label={question.question}
          value={value}
          onChange={handleChange}
          renderValue={(selected) =>
            Array.isArray(selected)
              ? selected
                  .map(
                    (val) =>
                      question.choices.find((c) => c.value === val)?.label || ""
                  )
                  .join(", ")
              : question.choices.find((c) => c.value === selected)?.label || ""
          }
        >
          {question.choices.map((choice, index) => (
            <MenuItem key={index} value={choice.value}>
              {choice.label}
            </MenuItem>
          ))}
        </Select>
        {question.description && (
          <Typography variant="caption" color="textSecondary" mt={1}>
            {question.description}
          </Typography>
        )}
      </FormControl>
    </Grid>
  );
};

export default Choice;
